<template>
    <div class="comment-page">
        <kw-common-pc-topbar contentwidth="1150" v-if="!isLeYou"></kw-common-pc-topbar>
        <kw-common-pc-lytopbar contentwidth="1150" v-if="isLeYou"></kw-common-pc-lytopbar>
        <common-framework  class='comment-module' name="意见与建议">
            <a-layout>
                <a-layout-sider width="180" class="sideBar-n"><SideBar class="side-bar-layout" :menuList="menu"></SideBar></a-layout-sider>
                <a-layout-content><router-view></router-view></a-layout-content>
            </a-layout>
        </common-framework>
    </div>
</template>
<script>
import { Layout } from 'ant-design-vue'
import { mapState, mapMutations } from 'vuex'
import FootBar from '@components/footBar'
import TopBar from '@components/topBar'
import CommonFramework from "@/shared/components/lyCommonFramework/index";
import { cookies } from '@utils'
import SideBar from './sideBar'

export default {
    data() {
        return {
            config: [],
            menu: []
        }
    },
    async created() {
        // this.$store.dispatch('getUserInfo')
        const { type = 'appPage' } = this.$route.query
        const res = await this.$store.dispatch('comment/getCMSConfig')
        const config = res.data || {}
        // 2022-04-24 安全修复，siteToken服务端设置为http-only，js读不到， 改用siteUserId判断
        // const siteToken = cookies.get('siteToken')
        // if (siteToken) {
        //     this.menu = config.menus
        // } else {
        //     this.menu = config.menus.filter(x => !x.needLogin)
        // }
        const siteUserId = cookies.get('siteUserId')
        if (siteUserId) {
            this.menu = config.menus
        } else {
            this.menu = config.menus.filter(x => !x.needLogin)
        }
    },
    components: {
        TopBar,
        FootBar,
        SideBar,
        CommonFramework,
        'a-layout':Layout,
        'a-layout-sider':Layout.Sider,
        'a-layout-content':Layout.Content
    }
}
</script>
<style lang="scss" scoped>
.comment-page{
    .ant-layout-sider {
        background-color: #fff;
        display: flex;
    }
    .ant-layout-content {
        margin-left: 15px;
    }
    .side-bar-layout {
        flex: 1 1 auto;
    }
}
</style>
